function packSmallRegions(items, floors, allowHidden) {
  for (let i = 0; i < items.length; i++) {
    const entry = items[i];
    if (allowHidden && entry.hidden) {
      entry.level = -100000; // big neg number to get item out of view;
    } else {
      const { g0: start, g1: end, size } = entry.variant?.region;
      if (size) {
        let currentFloor = 0;
        let found = false;
        while (!found) {
          if (currentFloor === floors.length) {
            floors.push({});
          }
          const floor = floors[currentFloor];
          for (let pos = start; pos < end; pos++) {
            if (floor[pos]) {
              currentFloor += 1;
              break;
            } else if (pos === end - 1) {
              found = true;
            }
          }
        }
        for (let pos = 0; pos < size; pos++) {
          floors[currentFloor][pos + start] = 2; // in contrast to additions (using 1).
        }
        entry.level = currentFloor;
      } else {
        let currentFloor = 0;
        let found = false;
        while (!found) {
          if (currentFloor === floors.length) {
            floors.push({});
          }
          const floor = floors[currentFloor];
          if (floor[start] || floor[start - 1] === 2) {
            currentFloor += 1;
          } else {
            found = true;
          }
        }
        floors[currentFloor][start] = 1;
        entry.level = currentFloor;
      }
    }
  }

  return floors;
}

export default packSmallRegions;
